import { Component, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.css']
})
export class CommonTableComponent {
  @Input() data: any[] = [];
  @Input() displayedColumns: { key: string, label: string, sortable?: boolean }[] = [];
  @ContentChild('actionButtons') actionTemplate!: TemplateRef<any>;

  @Output() sortChange = new EventEmitter<{ column: string, direction: 'asc' | 'desc' }>();

  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  onSort(columnKey: string) {
    if (this.sortColumn === columnKey) {
      // Toggle sorting direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Set new column for sorting
      this.sortColumn = columnKey;
      this.sortDirection = 'asc';
    }

    // Emit event to parent component
    this.sortChange.emit({ column: this.sortColumn, direction: this.sortDirection });
  }
}
